const { max: maxOf, floor, random } = Math;

export const getRandomNumberInRange = (min: number, max: number): number =>
  maxOf(min, floor(random() * maxOf(max, min)));
